import { api } from "lwc";
import ButtonIcon from "tds/buttonIcon";

const countSizeClassNames = ["", "", "size--medium", "size--large"];
class ButtonIconCount extends ButtonIcon {
  @api maxCount = 50;
  @api href = null;
  @api target = null;
  @api rel = null;
  @api count = 0;
  @api size = "large";
  @api sprite = "utility";
  @api symbol = null;
  @api variant = "bare";

  get formattedCount() {
    return this.count > this.maxCount ? `${this.maxCount}+` : `${this.count}`;
  }

  get showCount() {
    return this.count > 0;
  }

  get countClassName() {
    const numChars = this.formattedCount.length;
    let sizeClass = countSizeClassNames[numChars];

    if (sizeClass === undefined) {
      sizeClass = "size--large";
    }

    return `button-icon-count__count ${sizeClass}`;
  }
}

export default ButtonIconCount;
